<template>
  <div>
    <Products
      :finance_configuration_category="finance_configuration_category"
      @get_finance_configuration_category="financeConfigurationCategory"
    />
  </div>
</template>

<script>
import Products from "./item-products/products";

import api from "../../../services/api";

import { getRestHomeSelectedFinancialAccount } from "../../../lib/functions";

export default {
  name: "ItemProducts",

  components: {
    Products,
  },

  data() {
    return {
      errors: [],

      loading: false,

      finance_configuration_category: [],
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    getRestHomeSelectedFinancialAccount,

    retrieve() {
      this.financeConfigurationCategory();
    },

    async financeConfigurationCategory() {
      try {
        let rest_home_id_selected_financial_account =
          this.getRestHomeSelectedFinancialAccount();

        let params = {
          rest_home_id_selected_financial_account,
        };

        const response = await api.get(
          "/rest-home/financial/configuration/category-actives",
          {
            params,
          }
        );

        const { data } = response.data;

        this.finance_configuration_category = data;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
